import { combineReducers } from 'redux'

import login from './login'
import signup from './signup'
import users from './users'
import contratos from './contratos'
import indicacoes from './indicacoes'
import aportes from './aportes'
import resgates from './resgates'
import wallet from './wallet'
import wallet_brl from './wallet_brl'
import wallet_btc from './wallet_btc'
import wallet_transactions from './wallet_transactions'
import wallet_token from './wallet_token'

export default combineReducers({
    login,
    signup,
    users,
    contratos,
    indicacoes,
    aportes,
    resgates,
    wallet,
    wallet_brl, 
    wallet_btc,
    wallet_transactions,
    wallet_token
})